import { AppState } from '@app/state';

export function getLoading(state: AppState): boolean {
  return state.core.loadingGet > 0;
}

export function getLoadingElse(state: AppState): boolean {
  return state.core.loadingElse > 0;
}
